import { api } from "./api";

// A connection granted to an app that has collaborators is a credential shared
// with them (they can read it as the app does), so the grant is followed by a
// warning toast naming that. The toast is global (App.jsx mounts it), since
// grants happen from several surfaces -- the app's Connections tab, the
// assistant's chips and popover, the chats menu -- none of which own a toast.
export const TOAST_EVENT = "hostit:toast";

// sharedGrantMessage is the toast for n collaborators; empty for none.
export function sharedGrantMessage(n, label) {
  if (!n) return "";
  const who = n === 1 ? "your collaborator" : `your ${n} collaborators`;
  return `You just shared ${label ? `"${label}"` : "this credential"} with ${who}: they can use it as this app does.`;
}

// warnIfShared shows the warning after a grant on app `name`, if it has
// collaborators. Best effort: a failed lookup shows nothing.
export async function warnIfShared(name, label) {
  let people = [];
  try {
    people = (await api.get(`/api/apps/${encodeURIComponent(name)}/collaborators`)) || [];
  } catch {
    return;
  }
  const message = sharedGrantMessage(people.length, label);
  if (message) window.dispatchEvent(new CustomEvent(TOAST_EVENT, { detail: { message, warn: true } }));
}
